window.sections = [...document.querySelectorAll('.scrollcontent')];
window.lastScrollTop = window.pageYOffset;

document.body.style.background = window.sections[0].getAttribute('data-bg');

document.querySelector('.section-scroll').addEventListener('scroll', onScroll);

function onScroll(e) {
  const scrollTop = window.pageYOffset;
  
  const section = window.sections
    .map(section => {
      const el = section;
      const rect = el.getBoundingClientRect();
      return {el, rect};
    })
    .find(section => section.rect.bottom >= (window.innerHeight * 0.5));
  e.target.style.background = section.el.getAttribute('data-bg');

  document.querySelectorAll('.title_scroll').forEach((t) => {console.log('test');
    if (section.el.getAttribute('data-content-scroll') == t.getAttribute('data-scroll-id')) {
      t.classList.add('active');
    } else {
      t.classList.remove('active');
    } 
  })
}

let scrollSection = document.querySelector('.section-scroll');
if(scrollSection){
  let scrollSectionTop = scrollSection.getAttribute('data-padding-top');
  let scrollSectionBottom = scrollSection.getAttribute('data-padding-bottom');
  let scrollItemHeight = document.querySelectorAll('.scrollcontent')[0].offsetHeight;
  if (window.innerWidth > 749) {
    scrollSection.style.height = scrollItemHeight + Number(scrollSectionTop) + Number(scrollSectionBottom) + 'px';
  }
}
